export { default } from "./AvatarCreationModal";
